"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { Brain, Vote, Star } from "lucide-react";
import { PillToggle } from "@/components/ui/controls/PillToggle";
import type { Category } from "./games-votes/types";
import { useGamesVotesData } from "./games-votes/useGamesVotesData";
import QuizCard from "./games-votes/QuizCard";
import PollCard from "./games-votes/PollCard";
import PotmCard from "./games-votes/PotmCard";
import { CardSkeleton, EmptyState, LoadMoreButton } from "./shared";
interface GamesVotesHistoryProps {
  labels: Record<string, string>;
}
const CATEGORIES: Array<{
  id: Category;
  labelKey: string;
  fallback: string;
}> = [{
  id: "quizzes",
  labelKey: "categoryQuizzes",
  fallback: "Quizzes"
}, {
  id: "polls",
  labelKey: "categoryPolls",
  fallback: "Polls"
}, {
  id: "potm",
  labelKey: "categoryPotm",
  fallback: "Player of the Match"
}];
export default function GamesVotesHistory(t0) {
  const $ = _c(21);
  const {
    labels
  } = t0;
  const [category, setCategory] = useState("quizzes");
  const {
    quizzes,
    polls,
    potm,
    loadMoreQuizzes,
    loadMorePolls,
    loadMorePotm
  } = useGamesVotesData(category);
  const loading = category === "quizzes" ? quizzes.loading : category === "polls" ? polls.loading : potm.loading;
  const t1 = labels.gamesVotesHistory || "Games & Votes";
  let t2;
  if ($[0] !== t1) {
    t2 = <h2 className="mb-4 text-lg font-semibold text-foreground">{t1}</h2>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== labels) {
    t3 = CATEGORIES.map(cat => ({
      id: cat.id,
      label: labels[cat.labelKey] || cat.fallback
    }));
    $[2] = labels;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== category || $[5] !== t3) {
    t4 = <PillToggle options={t3} activeId={category} onChange={setCategory} size="md" className="mb-4" />;
    $[4] = category;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== category || $[8] !== labels || $[9] !== loadMorePolls || $[10] !== loadMorePotm || $[11] !== loadMoreQuizzes || $[12] !== loading || $[13] !== polls || $[14] !== potm || $[15] !== quizzes) {
    t5 = loading ? <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">{Array.from({
        length: 6
      }).map(_temp)}</div> : <>{category === "quizzes" && (quizzes.items.length === 0 ? <EmptyState icon={Brain} label={labels.noQuizzes || "No quiz participations yet"} /> : <><div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">{quizzes.items.map(q => <QuizCard key={q.classicQuizId} quiz={q} labels={labels} />)}</div>{quizzes.cursor && <LoadMoreButton loading={quizzes.loadingMore} onClick={loadMoreQuizzes} label={labels.loadMore || "Load More"} />}</>)}{category === "polls" && (polls.items.length === 0 ? <EmptyState icon={Vote} label={labels.noPolls || "No poll votes yet"} /> : <><div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">{polls.items.map(v => <PollCard key={v.id} vote={v} labels={labels} />)}</div>{polls.cursor && <LoadMoreButton loading={polls.loadingMore} onClick={loadMorePolls} label={labels.loadMore || "Load More"} />}</>)}{category === "potm" && (potm.items.length === 0 ? <EmptyState icon={Star} label={labels.noPotm || "No POTM votes yet"} /> : <><div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">{potm.items.map((v_0, i_0) => <PotmCard key={`${v_0.matchId}-${i_0}`} vote={v_0} labels={labels} />)}</div>{potm.cursor && <LoadMoreButton loading={potm.loadingMore} onClick={loadMorePotm} label={labels.loadMore || "Load More"} />}</>)}</>;
    $[7] = category;
    $[8] = labels;
    $[9] = loadMorePolls;
    $[10] = loadMorePotm;
    $[11] = loadMoreQuizzes;
    $[12] = loading;
    $[13] = polls;
    $[14] = potm;
    $[15] = quizzes;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t2 || $[18] !== t4 || $[19] !== t5) {
    t6 = <div>{t2}{t4}{t5}</div>;
    $[17] = t2;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
}
function _temp(_, i) {
  return <CardSkeleton key={i} />;
}